export default "__VITE_ASSET__63AVgVN$__"